import React from "react";
import InputField from "../../../components/inputField/InputField";
import { searchIcon } from "../../../assets";
import DashHeader from "../../../components/dashHeader/DashHeader";
import Modal from "../../../components/modal/Modal";
import Form from "../../../components/form/Form";
import useGuards from "./useGuards";
import { GUARDS_FORM } from "../../../constants/guards.form.constants";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { SetTable } from "@/components/SetTable";

const Guards: React.FC = () => {
  const {
    isModalOpen,
    handleModal,
    searchValue,
    handleSearchChange,
    filteredGuards,
    loading,
    control,
    errors,
    methods,
    handleSubmit,
    isSubmitting,
    onSubmit,
    isEdit,
    actions,
  } = useGuards();
  const guardstableKeys = [
    {
      name: "name",
    },
    {
      username: "username",
    },
    {
      contact: "contactNumber",
    },
    {
      shiftStart: "shiftStartTime",
    },
    {
      shiftEnd: "shiftEndTime",
    },
    {
      password: "plainTextPassword",
    },
  ];
  return (
    <>
      <DashHeader title="Guards" />
      <div className="flex justify-between px-3   ">
        <div className="w-full md:w-[327px]">
          <InputField name="search" type="text" placeholder="Search Here..." value={searchValue} onChange={handleSearchChange} icon={searchIcon} />
        </div>
        <Button variant="default" onClick={handleModal}>
          Add New Guard
        </Button>
      </div>
      {loading ? (
        <div className="flex justify-center items-center h-32 mt-12">
          <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-blue-500 border-solid border-b-transparent"></div>
        </div>
      ) : (
        <div className="">
          <Card className="p-5">
            <SetTable data={filteredGuards} tableKeys={guardstableKeys} actions={actions} />
          </Card>
        </div>
      )}
      <Modal
        isModalOpen={isModalOpen}
        onClick={handleModal}
        title={isEdit ? "Edit Guard" : "Add New Guard"}
      >
        <Form
          fields={GUARDS_FORM}
          control={control}
          method={methods}
          onClick={handleSubmit((data) => onSubmit(data))}
          errors={errors}
          isSubmitting={isSubmitting}
          style="grid grid-cols-2 gap-4"
        />
      </Modal>
    </>
  );
};

export default Guards;
